import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {GET_RISKS} from '../actiontypes';

export function getRisks(projectId, entityIds) {
	const url = `${Env.getBaseURL(serviceURL)}projects/${projectId}/RiskAssessmentDataInquiry`;
	const payload = {
		entityIds
	};
	return {
		type: GET_RISKS,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		}
	};
}
